"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Details = _interopRequireDefault(require("./Details"));
var _helpers = require("./helpers");
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SyncSummary = function SyncSummary(_ref) {
  var summary = _ref.summary,
    header = _ref.header;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert alert-info"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].syncSummary
  }, /*#__PURE__*/_react["default"].createElement("h4", null, header), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-unstyled"
  }, summary.sites && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, (0, _helpers.getLabel)('groups', 'site', 'Sites'), ":"), " ", /*#__PURE__*/_react["default"].createElement(_Details["default"], {
    countObject: summary.sites
  })), summary.siteAdmins && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, (0, _helpers.getLabel)('roles', 'siteAdmin', 'Site Admin'), ":"), ' ', /*#__PURE__*/_react["default"].createElement(_Details["default"], {
    countObject: summary.siteAdmins
  })), summary.instructors && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, (0, _helpers.getLabel)('roles', 'instructor', 'Instructors'), ":"), ' ', /*#__PURE__*/_react["default"].createElement(_Details["default"], {
    countObject: summary.instructors
  })), summary.classes && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, (0, _helpers.getLabel)('groups', 'class', 'Classes'), ":"), " ", /*#__PURE__*/_react["default"].createElement(_Details["default"], {
    countObject: summary.classes
  })), summary.learners && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, (0, _helpers.getLabel)('roles', 'learner', 'Learners'), ":"), ' ', /*#__PURE__*/_react["default"].createElement(_Details["default"], {
    countObject: summary.learners
  })))), Array.isArray(summary.bySite) && summary.bySite.length > 0 && /*#__PURE__*/_react["default"].createElement("ul", {
    className: 'list-unstyled ' + _style["default"].siteList
  }, summary.bySite.sort(function (a, b) {
    return a.name < b.name;
  }).map(function (siteSummary, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].siteSummary,
      key: siteSummary.name + i
    }, /*#__PURE__*/_react["default"].createElement("h4", null, siteSummary.name), siteSummary.siteAdmins && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, (0, _helpers.getLabel)('roles', 'siteAdmin', 'Site Admin')), ":", ' ', /*#__PURE__*/_react["default"].createElement(_Details["default"], {
      countObject: siteSummary.siteAdmins
    })), siteSummary.instructors && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, (0, _helpers.getLabel)('roles', 'instructor', 'Instructors')), ":", ' ', /*#__PURE__*/_react["default"].createElement(_Details["default"], {
      countObject: siteSummary.instructors
    })), siteSummary.classes && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, (0, _helpers.getLabel)('groups', 'class', 'Classes')), ":", ' ', /*#__PURE__*/_react["default"].createElement(_Details["default"], {
      countObject: siteSummary.classes
    })), siteSummary.learners && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, (0, _helpers.getLabel)('roles', 'learner', 'Learners')), ":", ' ', /*#__PURE__*/_react["default"].createElement(_Details["default"], {
      countObject: siteSummary.learners,
      byGradeProps: {
        byGrade: siteSummary.byGrade,
        studentLabel: (0, _helpers.getLabel)('roles', 'learner', 'Learners')
      }
    })));
  })));
};
SyncSummary.propTypes = {
  summary: _propTypes["default"].shape({
    sites: _propTypes["default"].object,
    siteAdmins: _propTypes["default"].object,
    instructors: _propTypes["default"].object,
    classes: _propTypes["default"].object,
    learners: _propTypes["default"].object
  }).isRequired,
  header: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string])
};
SyncSummary.defaultProps = {
  header: 'Sync summary'
};
var _default = exports["default"] = SyncSummary;